/*
 * @Author: Tina Huang
 * @Date: 2024-05-13 12:12:39
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-05-14 09:35:38
 * @Description:
 */

import http from './http'
import httpLocal from './http_local'

export const createDairy = (data: object) => {
  return http.post('/notion/dairy/create', data)
}

// local
export const getVipPicks = () => {
  return httpLocal.get('/notion_data.json')
}
